import { Component, Input, OnChanges, OnInit } from "@angular/core";
import { NavigationService } from "src/services/navigation/navigation.service";
import { AuthService } from "src/services/auth/auth.service";
import { SubscriptionTypeService } from "../../../../services/subscription-type/subscription-type.service";
import { BasePlanCardComponent } from "./base-plan-card.component";
import { CheckoutService } from "src/services/checkout/checkout.service";
import { ActiveSubscription } from "../../../../shared/backend-api.types";
import { PlanFrequency, PlanUniqueId } from "../../../../services/subscription-type/subscription-type.interface";

@Component({
  selector: "rc-plan-card-from-subscription",
  templateUrl: "./plan-card-from-plan.component.html",
  styleUrls: ["./plan-card-from-plan.component.scss"],
  standalone: false,
})
export class PlanCardFromSubscriptionComponent extends BasePlanCardComponent implements OnInit, OnChanges {
  @Input() public subscription: ActiveSubscription;

  public showActionButton: boolean = false;

  constructor(
    protected readonly authService: AuthService,
    protected readonly checkoutService: CheckoutService,
    protected readonly navigationService: NavigationService,
    protected readonly subscriptionTypeService: SubscriptionTypeService,
  ) {
    super(authService, checkoutService, navigationService, subscriptionTypeService);
  }

  public async ngOnInit(): Promise<void> {
    this.frequency = this.subscription.frequency === "annual" ? PlanFrequency.annual : PlanFrequency.monthly;
    this.planId = this.subscription.externalSubscriptionTypeId as PlanUniqueId;
    await super.ngOnInit();
  }

  protected async fetchPrice(): Promise<void> {
    this.price = this.formatPrice(this.subscription.price);
    this.priceWithoutDiscount = this.price;
  }
}
